export default "__VITE_ASSET__yq11EHUc__"